"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiFactory = void 0;

var _MultiBackendImpl = require("./MultiBackendImpl");

var MultiFactory = function MultiFactory(manager, context, options) {
  return new _MultiBackendImpl.MultiBackendImpl(manager, context, options);
};

exports.MultiFactory = MultiFactory;